<template>
  <div>
    <el-dialog
      :title="dataForm.id ? 'Edit Exchange Rate' : 'Add Exchange Rate'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="600px"
      top="2vh"
    >
      <el-form :model="dataForm" :rules="dataRule" ref="formRef" autocomplete="off" label-width="130px" label-position="left">
        <el-row :gutter="60">
          <el-col :span="16">
            <el-form-item label="End of Period" prop="month">
              <el-date-picker
                v-model="dataForm.month"
                type="month"
                value-format="yyyyMM"
                clearable
                placeholder="Select Month"
                class="wdb100"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-table :data="dataForm.tableDataList" class="wdb100" height="63vh">
              <el-table-column label="Exchange Rates" align="left">
                <template slot-scope="scope">
                  <span>S$ Per {{ scope.row.exchangeRateBasis }} Units of {{ scope.row.currency }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" width="200">
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.exchangeRateValue"
                    :precision="6"
                    :min="0"
                    :step="0.000001"
                    controls-position="right"
                    class="tal wdb100"
                  ></el-input-number>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" class="pt16">
            <el-form-item label="Attachments" prop="attachmentUrls">
              <el-multiple-file-uploader v-model="dataForm.attachmentUrls"></el-multiple-file-uploader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { isNumberLike } from "@/utils";
export default {
  props: {
    exRateCurrencyExclusiveList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      dataForm: {
        id: null,
        month: "",
        tableDataList: [],
        attachmentUrls: [],
      },
      dataRule: {
        month: [{ required: true, message: "Please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  methods: {
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.dialogVisible = true;
      await this.$nextTick();
      this.$refs.formRef.resetFields();
      const dataCopy = data || {};
      const detailList = dataCopy.detailList || [];

      const tableDataList = this.exRateCurrencyExclusiveList
        .filter(item => item.currency !== "SGD")
        .map(item => {
          const detailItem = detailList.find(ele => ele.currency === item.currency);
          return {
            currency: item.currency,
            exchangeRateBasis: item.exchangeRateBasis,
            exchangeRateValue: detailItem?.exchangeRateValue,
          };
        });

      this.dataForm = {
        id: dataCopy.id ?? null,
        month: dataCopy.month ?? "",
        tableDataList,
        attachmentUrls: dataCopy.attachmentUrls || [],
      };
    },
    // 表单提交
    async formSubmitRequest() {
      const detailList = [];
      this.dataForm.tableDataList.forEach(item => {
        const exchangeRateValue = item.exchangeRateValue;
        if (isNumberLike(exchangeRateValue)) {
          detailList.push({
            currency: item.currency,
            exchangeRateBasis: item.exchangeRateBasis,
            exchangeRateValue,
          });
        }
      });
      const params = {
        ...this.dataForm,
        detailList,
      };
      if (params.id) {
        return await this.$http.put(`/admin/exchangeRateByMonth/${params.id}`, params);
      } else {
        return await this.$http.post("/admin/exchangeRateByMonth", params);
      }
    },
    dataFormSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false;
                  this.$emit("update");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
